// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes spinAround-data-v-4d392644{from{transform:rotate(0deg)}to{transform:rotate(359deg)}}.v-skeleton-loader[data-v-4d392644]{opacity:0.7}\n", ""]);
// Exports
module.exports = exports;
